import type { TranslateDictionary } from './en.js';

export const Sr: TranslateDictionary = {
  'Start airplay': 'Pokreni AirPlay',
  'Stop airplay': 'Zaustavi AirPlay',
  Audio: 'Audio',
  Captions: 'Natpisi',
  'Enable captions': 'Omogući natpise',
  'Disable captions': 'Onemogući natpise',
  'Start casting': 'Pokreni prenos',
  'Stop casting': 'Zaustavi prenos',
  'Casting to {device}': 'Prebacivanje na {device}',
  'Enter fullscreen mode': 'Uključi prikaz celog ekrana',
  'Exit fullscreen mode': 'Isključi prikaz celog ekrana',
  Mute: 'Privremeno isključi',
  Unmute: 'Ponovo uključi',
  'Enter picture in picture mode': 'Aktiviraj režim slika-u-slici',
  'Exit picture in picture mode': 'Deaktiviraj režim slika-u-slici',
  Play: 'Reprodukuj',
  Pause: 'Pauziraj',
  'Playback rate': 'Brzina reprodukcije',
  'Playback rate {playbackRate}': 'Brzina reprodukcije {playbackRate}',
  Quality: 'Kvalitet',
  'Seek backward': 'Premotaj nazad',
  'Seek forward': 'Premotaj napred',
  Settings: 'Postavke',
  Auto: 'Auto',
  'audio player': 'audio plejer',
  'video player': 'video plejer',
  volume: 'Jačina zvuka',
  seek: 'Traži',
  'closed captions': 'Natpisi',
  'current playback rate': 'trenutna brzina reprodukcije',
  'playback time': 'vreme reprodukcije',
  'media loading': 'učitavanje medija',
  settings: 'Postavke',
  'audio tracks': 'audio zapisi',
  quality: 'Kvalitet',
  play: 'reprodukuj',
  pause: 'pauziraj',
  mute: 'privremeno isključi',
  unmute: 'ponovo uključi',
  'chapter: {chapterName}': 'poglavlje: {chapterName}',
  live: 'uživo',
  Off: 'Isključeno',
  'start airplay': 'pokreni AirPlay',
  'stop airplay': 'zaustavi AirPlay',
  'start casting': 'pokreni prenos',
  'stop casting': 'zaustavi prenos',
  'enter fullscreen mode': 'uključi prikaz celog ekrana',
  'exit fullscreen mode': 'isključi prikaz celog ekrana',
  'enter picture in picture mode': 'aktiviraj režim slika-u-slici',
  'exit picture in picture mode': 'deaktiviraj režim slika-u-slici',
  'seek to live': 'idi na uživo',
  'playing live': 'reprodukcija uživo',
  'seek back {seekOffset} seconds': 'premotaj nazad {seekOffset} sekundi',
  'seek forward {seekOffset} seconds': 'premotaj napred {seekOffset} sekundi',
  'Network Error': 'Greška mreže',
  'Decode Error': 'Greška dekodiranja',
  'Source Not Supported': 'Izvor nije podržan',
  'Encryption Error': 'Greška šifrovanja',
  'A network error caused the media download to fail.':
    'Greška mreže je prouzrokovala neuspeh preuzimanja medija.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Greška medija je prouzrokovala prekid reprodukcije. Medij može biti oštećen ili vaš pretraživač ne podržava ovaj format.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Došlo je do nepodržane greške. Server ili mreža su otkazali, ili vaš pretraživač ne podržava ovaj format.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Medij je šifrovan i nema ključeva za dešifrovanje.',
};
